export class BonusPoints {
    value: number;

    constructor(value: number) {
        this.value = value;
    }

    getFormatted(): string {
        // Attention: We format the points our self because we cannot use "toLocaleString".
        // In the Point4More service portal on the IE 11 "toLocaleString" will append two fraction digits. We don't know why.
        const absStr = Math.floor(Math.abs(this.value)).toString();
        const slices = Math.ceil(absStr.length / 3);
        const absFormatted = Array(slices)
            .fill(undefined)
            .map((_, i) => absStr.slice(-3 * (slices - i), -3 * (slices - i - 1) || undefined))
            .join('.');
        return `${this.value < 0 ? '-' : ''}${absFormatted}`;
    }
}
